const GOOGLE_API_KEY = 'AIzaSyDAwk4yG4v0Bs4KAlonLTfwe2Qzw5LV2AI';

export const OFFSET_LIVE_CHAT = 25;

export const  YOUTUBE_VIDEOS_API = 'https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&regionCode=US&maxResults=50&key='+GOOGLE_API_KEY;

export const YOUTUBE_SEARCH_API = 'http://suggestqueries.google.com/complete/search?client=firefox&ds=yt&q=';